<template>
  <div>
    <b-row>
      <b-col cols="12" md="12">
        <div class="position-relative">
          <!-- <img style="width: 100%;height: 600px;" :src="asset(`media/welcome-fitness.png`)" /> -->

          <!-- <div class="position-absolute welcome-message">
            Halo, {{ currentUser.name }}<br />
            <span class="h3">Selamat datang di dasbor Awr Fitness</span>
          </div> -->
        </div>
      </b-col>

      <!-- gym chart -->
      <b-col cols="12" md="12">
        <GymChart />
      </b-col>

      <!-- <b-col
        v-if="
          ['administrator'].includes(
            currentUser.activeRole.slug
          )
        "
        cols="12"
        md="6"
      >
        <router-link
          to="/admin/blog/artikel"
          v-slot="{ href, navigate }"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <div
              v-ripple
              class="card card-custom wave wave-animate-slow mb-8 mb-lg-0 shadow-sm"
            >
              <div class="card-body">
                <div class="d-flex align-items-center p-5">
                  <div class="mr-6">
                    <i
                      class="menu-icon flaticon-folder-1 icon-3x text-primary"
                    ></i>
                  </div>
                  <div class="d-flex flex-column">
                    <div
                      class="text-primary font-weight-bold font-size-h4 mb-1"
                    >
                      Artikel
                    </div>
                    <div class="text-dark-75">
                      Lihat artikel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </b-col> -->

      <!-- <b-col
        v-if="
          ['administrator'].includes(
            currentUser.activeRole.slug
          )
        "
        cols="12"
        md="6"
      >
        <router-link
          to="/admin/persona/anggota"
          v-slot="{ href, navigate }"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <div
              v-ripple
              class="card card-custom wave wave-animate-slow mb-8 mb-lg-0 shadow-sm"
            >
              <div class="card-body">
                <div class="d-flex align-items-center p-5">
                  <div class="mr-6">
                    <i
                      class="menu-icon flaticon2-calendar-5 icon-3x text-primary"
                    ></i>
                  </div>
                  <div class="d-flex flex-column">
                    <div
                      class="text-primary font-weight-bold font-size-h4 mb-1"
                    >
                      Persona
                    </div>
                    <div class="text-dark-75">
                      Lihat Persona
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </b-col> -->
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
.welcome-message {
  bottom: 20px;
  left: 25px;
  color: #ffffff;
  font-size: 18px;
  line-height: 180%;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
import { asset } from "@/core/utils";
import GymChart from "../../../component/GymChart.vue";

export default {
  data() {
    return {
      user: this.$store.state.auth.user,
      activeRole: null
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dasbor", route: "" }]);
  },
  methods: {
    asset
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  components: {
    GymChart
  }
};
</script>

<style></style>
